import {
  Building2,
  ChevronLeft,
  ChevronRight,
  Flag,
  Globe,
  Layers,
  Radio,
  User,
  Users,
} from 'lucide-react';
import { SidebarItem } from './SidebarItem';
import { privatePaths } from '@/app/router/paths/privatePaths';
import { useAuthorization } from '@/core/hooks/useAuthorization';
import { UnifiedButton } from '@/shared/components/ui/unified-button';
import { PERMISSIONS } from '@/shared/constants/permissions';
import { cn } from '@/shared/lib/cn';

interface SidebarProps {
  collapsed: boolean;
  onToggle: () => void;
}

export function Sidebar({ collapsed, onToggle }: SidebarProps) {
  const { hasPermission } = useAuthorization();

  return (
    <div
      className={cn(
        'flex flex-col bg-background border-r border-outline h-[calc(100vh-4rem)] transition-all duration-300 overflow-hidden shrink-0',
        collapsed ? 'w-16' : 'w-64',
      )}
      style={{ scrollbarWidth: 'none' }}
    >
      <div className="w-full flex flex-col px-[1.25rem] py-[1.25rem] gap-1 flex-1">
        {!collapsed && <p className="text-navigation-title text-xs mb-1">Navegación</p>}
        {hasPermission(PERMISSIONS.USERS_LIST) && (
          <SidebarItem
            openSidebar={collapsed}
            title="Administradores"
            icon={<User size={16} />}
            path={privatePaths.ADMIN_USERS}
          />
        )}
        {hasPermission(PERMISSIONS.COUNTRIES_LIST) && (
          <SidebarItem
            openSidebar={collapsed}
            title="Países"
            icon={<Flag size={16} />}
            path={privatePaths.COUNTRIES}
          />
        )}
        {hasPermission(PERMISSIONS.REGIONS_LIST) && (
          <SidebarItem
            openSidebar={collapsed}
            title="Regiones"
            icon={<Globe size={16} />}
            path={privatePaths.REGIONS}
          />
        )}
        {hasPermission(PERMISSIONS.SAAS_USERS_LIST) && (
          <SidebarItem
            openSidebar={collapsed}
            title="Clientes"
            icon={<Users size={16} />}
            path={privatePaths.END_USERS}
          />
        )}
        {hasPermission(PERMISSIONS.SOURCES_LIST) && (
          <SidebarItem
            openSidebar={collapsed}
            title="Fuentes"
            icon={<Radio size={16} />}
            path={privatePaths.SOURCES}
          />
        )}
        {hasPermission(PERMISSIONS.PLANS_MANAGE) && (
          <SidebarItem
            openSidebar={collapsed}
            title="Planes"
            icon={<Layers size={16} />}
            path={privatePaths.PLANS}
          />
        )}
        {hasPermission(PERMISSIONS.TENANTS_LIST) && (
          <SidebarItem
            openSidebar={collapsed}
            title="Espacios de trabajo"
            icon={<Building2 size={16} />}
            path={privatePaths.TENANTS.home}
          />
        )}
      </div>
      <div className={cn('flex p-2', collapsed ? 'justify-center' : 'justify-end')}>
        <UnifiedButton
          onClick={onToggle}
          className="p-1 rounded-md hover:bg-select-background text-primary transition-colors"
          aria-label={collapsed ? 'Expandir sidebar' : 'Colapsar sidebar'}
        >
          {collapsed ? <ChevronRight size={24} /> : <ChevronLeft size={24} />}
        </UnifiedButton>
      </div>
    </div>
  );
}
